import { render, staticRenderFns } from "./AddComunity.vue?vue&type=template&id=08d734de&"
import script from "./AddComunity.vue?vue&type=script&lang=js&"
export * from "./AddComunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports